import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';
import {
  LoginRequest,
  LoginResponse
} from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { getGrpcPromise } from '@monorepo/grpc';

const loginMutator = ({
  login,
  password
}: LoginRequest.AsObject): Promise<LoginResponse.AsObject | null> => {
  // const token = getLocalStorageValue('firebase', '');

  const loginRequest = new LoginRequest();
  loginRequest.setLogin(login);
  loginRequest.setPassword(password);
  // if (token) {
  //   loginRequest.setDeviceToken(token);
  // }
  const loginGrpc = getGrpcPromise(WebAuthService.Login);
  return loginGrpc(loginRequest);
};

export default loginMutator;
